import { render, staticRenderFns } from "./OrdersAllSuppliers.vue?vue&type=template&id=27adf400&scoped=true&"
import script from "./OrdersAllSuppliers.vue?vue&type=script&lang=js&"
export * from "./OrdersAllSuppliers.vue?vue&type=script&lang=js&"
import style0 from "./OrdersAllSuppliers.vue?vue&type=style&index=0&id=27adf400&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27adf400",
  null
  
)

export default component.exports